<template>
  <div class="question-pinglun">
    <div class="no-answer" v-if="total == 0">
      暂无答案，快抢沙发<br>
      <el-button size="mini" type="primary" @click="showEdit">添加回答</el-button>
    </div>
    <div class="ans-view-text" v-if="showEditText">
      <rich-text v-if="isReloadRechText"
       ref="richtext"
       class="item-wrap"
       v-model="form.content"
       placeholder="描述"/>
      <div class="sub-btns">
        <el-button @click="saveAns">保存</el-button>
        <el-button class="fabu" type="primary"  @click="pubAns">发布</el-button>
      </div>
    </div>
    <!--答案排序方式-->
    <div class="select-some" v-if="total >0">
      <span class="all">全部答案</span>
      <ul class="sel-cont">
        <li :class="{'active': hotState !== null && currentState === 0}" @click="selHotState">
          热门
          <i class="el-icon-sort-down" v-if="hotState === false"></i>
          <i class="el-icon-sort-up" v-if="hotState === true"></i>
        </li>
        <li :class="{'active': dateState !== null && currentState === 1}" @click="selDateState">
          时间
          <i class="el-icon-sort-down" v-if="dateState === false"></i>
          <i class="el-icon-sort-up" v-if="dateState === true"></i>
        </li>
      </ul>
    </div>
    <!--    答案列表-->
    <div class="talk-show" v-if="total >0">
      <answer-item :answerData="answerData" v-if="isReload" :queAcceptId="questionObj.accept" :queUserId="questionObj.userId"></answer-item>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import richText from './richtext'
import answerItem from './answer'

import answerApi from "@/api/answer";

export default {
  components: {
    richText,
    answerItem
  },
  props: ['answerTo','questionObj','aId'],
  data () {
    return {
      richtext: '',
      showEditText: false,
      currentState: 1,
      hotState: null,
      dateState: true,
      isReload: true,
      isReloadRechText: true,
      param:{
        orderType:"time1",
        publishStatus: 1,
        deleteFlag: 0,
        answerto:0,
        pageIndex: 1,
        pageSize: 12,
      },
      answerData:[],//列表数据
      total:0,

      form: {
        id:0,
        // title:'',			//标题
        supportcnt:0,		// 赞数
        opposecnt:0,		//踩数
        answerto:0,		//问题ID
        time:'',		//创建时间
        userId:0,		//用户ID
        accept:0,			//是否采纳		(0为否；1为是；)
        praise:0,			//是否最佳		(0为否；1为是；)
        commentCount:0,	//评论数
        shareCount:0,	//分享数
        reportCount:0,	//举报数
        collectCount:0,	//收藏数
        auditStatus:0,		//审核状态		(-1为未提交；0为待审核；1为审核通过；2为审核未通过；)
        publishStatus:0,	//发布状态 (0为未发布；1为发布；)
        publishDate:'',		//发布日期
        deleteFlag:-1,		//删除标识 (-1为草稿；0为正常；1为删除；)
        content:'',			//内容
      },
    }
  },
  mounted () {
    this.param.answerto = this.answerTo
    this.form.answerto = this.answerTo
    //编辑回答
    if(this.aId > 0){
      this.answerEdit(this.aId)
    }
    this.getAnswer(1)
  },
  methods: {

    getAnswer(page){
      let thiss = this
      thiss.listLoading = true
      thiss.param.pageIndex = page
      answerApi.getPage(thiss.param).then(reAnswer => {
        thiss.answerData = reAnswer.list
        if(reAnswer){
          //对富文本内容处理
          // let re1 =new RegExp("<.+?>",'g');//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
          // thiss.answerData.forEach((item,index) =>{
          //   item.content = item.content.replace(re1,'');//执行替换成空字符
          // })
          thiss.total = reAnswer.total
          thiss.param.pageIndex = reAnswer.pageNum
          thiss.listLoading = false

          thiss.$parent.setAnswerNum(thiss.total)

          thiss.reLoadTick();
        }else{
          thiss.$parent.setAnswerNum(thiss.total)
          thiss.reLoadTick();
        }

      })
    },


    //显示回答窗体
    answerEdit (aId) {
      let thiss = this
      answerApi.select(aId).then(re =>{
        if(re.code == -1){
          thiss.$message({
            message: re.message,
            type: 'error'
          });
          return false
        }else{
          if(thiss.global.userModel.id == re.response.userId){
            thiss.form = re.response
            thiss.reLoadTick()
            thiss.showEditText = true
          }else {
            thiss.$message.error("没有编辑权限")
            thiss.$router.push({
              path:'/quedetail',
              query: {id:re.response.answerto}
            })
          }

        }
      })
    },

    //显示回答窗体
    showEdit () {
      let thiss = this
      answerApi.selectDraft(thiss.answerTo).then(re =>{
        if(re.code == -1){
          thiss.$message({
            message: re.message,
            type: 'error'
          });
          return false
        }else{
          if(re.response == null){
            //无草稿
            //thiss.initData()
            thiss.form.id = 0
          }else{
            thiss.form = re.response
            thiss.reLoadTick()
          }

          thiss.showEditText = true
        }
      })
    },
    saveAns () {
      this.showEditText = false

      let thiss =this
      //获取子组件值
      thiss.form.content = thiss.$refs.richtext.content
      if(thiss.form.content.trim() ==''){
        thiss.$message.error('内容不能为空!')
        return false
      }

      thiss.form.auditStatus =-1 //审核通过状态
      thiss.form.deleteFlag = -1 //未删除，非草稿 状态
      thiss.form.publishStatus =0 //发布

      answerApi.update(thiss.form).then( re =>{
        // if(re.code == 1){
        //   thiss.reLoadTick()
        // }
        setTimeout(() =>{
          thiss.getAnswer(1)
        },1200)
      })
    },

    pubAns () {
      this.showEditText = false

      let thiss =this
      //获取子组件值
      thiss.form.content = thiss.$refs.richtext.content
      if(thiss.form.content.trim() ==''){
        thiss.$message.error('内容不能为空!')
        return false
      }

      thiss.form.auditStatus =1 //审核通过状态
      thiss.form.deleteFlag = 0 //未删除，非草稿 状态
      thiss.form.publishStatus =1 //发布
      thiss.form.publishDate = new Date()
      answerApi.update(thiss.form).then( re => {
        if(re.code == 1){
          thiss.form.auditStatus =-1
          thiss.form.deleteFlag = -1
          thiss.form.publishStatus =0
          thiss.form.publishDate = ''
          thiss.form.content = ''
          setTimeout(() =>{
            thiss.getAnswer(1)
          },1200)

        }else {
          thiss.$message({
            message:"发布失败",
            type:"error"
          })
        }
      })
    },
    selHotState () {
      this.currentState = 0
      this.dateState = null
      if(this.hotState === null){
        this.hotState = false
      } else {
        this.hotState = !this.hotState
      }

      if(this.hotState){
        this.param.orderType = "hot1"
      }else{
        this.param.orderType = "hot2"
      }
      this.getAnswer(1)
    },
    selDateState () {
      this.currentState = 1
      this.hotState = null
      if(this.dateState === null){
        this.dateState = false
      } else {
        this.dateState = !this.dateState
      }

      if(this.dateState){
        this.param.orderType = "time1"
      }else{
        this.param.orderType = "time2"
      }
      this.getAnswer(1)
    },


    //重置组建
    reLoadTick(){
      let thiss = this
      thiss.isReload = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      thiss.$nextTick(() => {
        thiss.isReload = true
      })
    },
    //重置组建
    reLoadRichTick(){
      let thiss = this
      thiss.isReloadRechText = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      thiss.$nextTick(() => {
        thiss.isReloadRechText = true
      })
    },

  }
}
</script>

<style scoped lang="less">
.question-pinglun{
  .select-some{
    padding: 10px;
    line-height: 24px;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    .all{
      cursor: pointer;
    }
    .sel-cont{
      float: right;
      li{
        float: left;
        margin-left: 10px;
        cursor: pointer;
        &::selection{
          display: none;
        }
        i{
          margin-left: -5px;
        }
        &.active{
          color: #409eff;
        }
      }
    }
  }
}
</style>
